import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

type ChatMessageInputProps = {
  onSendMessage: (message: string) => void;
  isWelcomeChat?: boolean;
};

export default function ChatMessageInput({ onSendMessage, isWelcomeChat = false }: ChatMessageInputProps) {
  const [newMessage, setNewMessage] = useState("");
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newMessage.trim() && !isWelcomeChat) {
      onSendMessage(newMessage);
      setNewMessage("");
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="flex w-full gap-2">
      <Textarea
        placeholder={isWelcomeChat ? "Invite team members to start chatting..." : "Type a message..."}
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        className="flex-1 min-h-[40px] max-h-[120px] resize-none"
        rows={1}
        disabled={isWelcomeChat}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (newMessage.trim() && !isWelcomeChat) {
              handleSubmit(e);
            }
          }
        }}
      />
      <Button 
        type="submit" 
        size="icon" 
        disabled={!newMessage.trim() || isWelcomeChat} 
        className="h-10 w-10 rounded-full"
      >
        <Send className="h-4 w-4" />
      </Button>
    </form>
  );
}
